module.exports = __webpack_public_path__ + "img/dame.8350766f.png";